// src/service/websocket/NiftyWebsocketApi.jsx

import { useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { environment } from "environment/environment"; // absolute import

const STOCK_API_WEBSOCKET_URL = environment.stockApiDayRangeDataWSUrl;

const useStockApiWebsocket = () => {
    const [options, setOptions] = useState([]);
    const [stockAnalysisData, setStockAnalysisData] = useState([]);
    const [stockSectorAnalysisData, setStockSectorAnalysisData] = useState([]);
    const [sectorialIndicesData, setSectorialIndicesData] = useState([]);
    const [strategyIndicesData, setStrategyIndicesData] = useState([]);
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return; // SSR safety

        const stompClient = new Client({
            webSocketFactory: () => new SockJS(STOCK_API_WEBSOCKET_URL),
            reconnectDelay: 5000, // auto-reconnect
            heartbeatIncoming: 10000,
            heartbeatOutgoing: 10000,
            debug: () => { }, // disable debug logs
        });

        stompClient.onConnect = () => {
            setIsConnected(true);
            const stockDayRangeDataTopic = environment.stoackApiTopic + environment.stockDayRangeDataTopic;

            stompClient.subscribe(stockDayRangeDataTopic, (message) => {
                try {
                    setOptions(JSON.parse(message.body));
                } catch (err) {
                    console.error("Failed to parse message:", err);
                }
            });

            const stockAnalysisTopic = environment.stoackApiTopic + environment.stockDataAnalysisTopic;
            stompClient.subscribe(stockAnalysisTopic, (message) => {
                try {
                    setStockAnalysisData(JSON.parse(message.body));
                } catch (err) {
                    console.error("Failed to parse message:", err);
                }
            });

            const stockSectorTopic = environment.stoackApiTopic + environment.stockSectorTopic;
            stompClient.subscribe(stockSectorTopic, (message) => {
                try {
                    setStockSectorAnalysisData(JSON.parse(message.body));
                } catch (err) {
                    console.error("Failed to parse message:", err);
                }
            });

            const sectorIndicesTopic = environment.stoackApiTopic + environment.sectorIndicestopic;
            stompClient.subscribe(sectorIndicesTopic, (message) => {
                try {
                    setSectorialIndicesData(JSON.parse(message.body));
                } catch (err) {
                    console.error("Failed to parse message:", err);
                }
            });

            const strategyIndicesTopic = environment.stoackApiTopic + environment.strategyIndiciesTopic;
            stompClient.subscribe(strategyIndicesTopic, (message) => {
                try {
                    setStrategyIndicesData(JSON.parse(message.body));
                } catch (err) {
                    console.error("Failed to parse message:", err);
                }
            });
        };

        stompClient.onStompError = (frame) => {
            console.error("Broker reported error:", frame.headers["message"]);
            console.error("Additional details:", frame.body);
        };

        stompClient.activate();

        return () => {
            if (stompClient.active) {
                stompClient.deactivate();
            }
        };
    }, []);

    return { options, stockAnalysisData, stockSectorAnalysisData, sectorialIndicesData, strategyIndicesData, isConnected };
};

export default useStockApiWebsocket;
